import { OpenInFull } from '@mui/icons-material';
import { IconButton, ImageList, ImageListItem, ImageListItemBar, LinearProgress, Link, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Api from '../../Api';
import { IMaterialImageGridProps } from '../../interfaces';
import { IImage } from '../../interfaces/Common/IImage';
import { MaterialImageDialog } from '../MaterialImageDialog';
import './index.scss';
import { NoDetailNotice } from './NoDetailNotice';

export const ImageGrid: React.SFC<IMaterialImageGridProps> = ({
    materialId,
    onUpload,
    ...props
}: IMaterialImageGridProps) => {

    const [imageList, setImageList] = useState<IImage[]>([]);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        if (materialId && loading === true)
            Api.Materials.get(materialId).then((response: any) => {
                setImageList(response.images);
                setLoading(false);
            });
    }, [materialId])


    return <>{

        loading ? <LinearProgress /> :


            imageList !== null && imageList.length > 0 ?
                <ImageList
                    variant="quilted"
                    cols={3}
                >
                    {imageList.map(image => (
                        <Tooltip title={image.title} >
                            <ImageListItem
                                key={image.imageId}
                                component={Link}
                                href={image.src}
                                target="_blank"
                                sx={{ cursor: "pointer" }}
                            >

                                <img
                                    src={image.src}
                                    srcSet={image.src}
                                    alt={image.title}
                                    loading="lazy"
                                />

                                <ImageListItemBar
                                    title={image.title}
                                    subtitle={<span>uploaded: {image.dateUploaded}</span>}
                                    actionIcon={
                                        <IconButton
                                            sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                            aria-label={`info about ${image.title}`}
                                        >
                                            <OpenInFull />
                                        </IconButton>
                                    }
                                />
                            </ImageListItem>
                        </Tooltip>
                    ))}

                </ImageList>
                :

                <Typography sx={{ mb: 2 }} color="GrayText"><NoDetailNotice label="images" /></Typography>

    }
        {onUpload !== undefined &&
            <MaterialImageDialog
                entityId={materialId}
                images={imageList}
                onImagesChanged={(images) => setImageList(images)}
                readonly={onUpload === undefined}
            />
        }
    </>
        ;
}